// The frame hosts Google's own One Tap prompt, which Google anchors to the top-right of its
// viewport, so the frame is anchored to the same corner.
// It keeps its size and stays visible at all times: GSI refuses to prompt inside a frame that is
// collapsed or `visibility: hidden`, and the prompt is what produces the `displayed` message, so
// sizing the frame only after that message would deadlock. What the component toggles instead is
// `pointer-events` (inline) — the frame is click-through until it actually shows something, which
// is what keeps the empty FedCM case from covering page content.
.sn-google-one-tap-type-2__frame {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1001;
  border: 0;
  background: transparent;
  color-scheme: normal;
}
